// extracted by mini-css-extract-plugin
module.exports = {"videoGallery":"VideoGallery_videoGallery___LZ_t"};